<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<br/><p style="text-indent:00em;">Penelope Alice is a software engineer. Raised in Buckinghamshire, she spends many happy hours walking in the countryside and visiting the local attractions.</p>
<br/><p style="text-indent:00em;">From a young age, Penelope has wanted to be a writer. She usually feels most relaxed making up stories and new worlds.</p>
<br/><p style="text-indent:00em;">Penelope’s passions include playing cello in her local orchestra, watching anime and drinking far too much tea.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?3fd8e272